import { ElMessage } from 'element-plus'
import { getLoginGaContext, openLoginDialog, setLoginGaContext } from '@/components/layout/LoginDialog/LoginDialog'
import { spaI18n } from '@/compositions/i18nPlugin'

function initForceMobile() {
  tools.forceMobile.value = !!localStorage?.getItem?.('forceMobile')
}
function initBuyOfferStoredForDeepLinkFlow() {
  const { buyOffer, getGameToken, checkBuyOfferWithApi } = gamesUtils
  const { gaLoginMethods } = gaUtils
  const rawBuyOffer = localStorage?.getItem?.('buyOffer')
  const buyOfferDeepLink: Games.Offer | null = rawBuyOffer ? JSON.parse(rawBuyOffer) : null
  const fakeLoadingRef = ref('')
  if (buyOfferDeepLink?.deepLink && tools.isMobileDevice.value) {
    buyOffer.value = {
      ...buyOfferDeepLink
    }
    if (!getGameToken(buyOfferDeepLink.gameKey)?.token) {
      openLoginDialog(buyOffer.value.gameKey, { ...getLoginGaContext(), ...{ method: gaLoginMethods.deepLink } })
      ElMessage({
        message: spaI18n.global.t('onMountedApp.deepLinkFailedMessage'),
        type: 'warning',
        customClass: 'store-warning',
        offset: 100,
        duration: 0,
        showClose: true
      })
    } else {
      checkBuyOfferWithApi(fakeLoadingRef)
      setLoginGaContext(null)
    }
  } else {
    buyOffer.value = null
    setLoginGaContext(null)
  }
  localStorage?.setItem?.('buyOffer', 'null')
}

function onMountedApp() {
  initForceMobile()
  initBuyOfferStoredForDeepLinkFlow()
}

const securedQueryParams = ref<Record<string, string>>({})

export { onMountedApp, securedQueryParams }
